export const FILTER_DEBOUNCE_TIME = 350;

export const toFilterRequest = (name, { filterVal }) => ({
    [name]: filterVal
});